<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <tab-nav :pills="true" class="iq-edit-profile d-flex pill-theme">
          <tab-nav-items :active="true" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-billing-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="far fa-building"></i>
                </div>
                {{
                  $t("public.components.organization.preferences.btnBilling")
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-preferences-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-cogs"></i>
                </div>
                {{
                  $t(
                    "public.components.organization.preferences.bntPreferences"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-customize-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-magic"></i>
                </div>
                {{
                  $t("public.components.organization.preferences.btnCustomize")
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items v-if="role === 'ADMIN'" :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-account-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                </div>
                {{
                  $t("public.components.organization.preferences.btnAccount")
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items v-if="superUser" :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-template-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-clone"></i>
                </div>
                Plantillas
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items v-if="superUser" :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-footer-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-list"></i>
                </div>
                Pie de página
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items v-if="superUser" :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-email-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-envelope"></i>
                </div>
                Emails
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items v-if="superUser" :active="false" :class="`p-0 ${role === 'ADMIN'
            ? superUser
              ? 'col-md-2'
              : 'col-md-3'
            : 'col-md-4'
            }`" href="#preferences-superuser-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <div class="
                                                    rounded-circle
                                                    iq-card-icon
                                                    title-typography-color
                                                    bg-white
                                                    mr-2
                                                  ">
                  <i aria-hidden="true" class="fas fa-cogs"></i>
                </div>
                ADMIN CITA.IO
              </h4>
            </template>
          </tab-nav-items>
        </tab-nav>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <tab-content id="pills-tabContent-1">
          <tab-content-item id="preferences-billing-tab" :active="true">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="far fa-building"></i>
                  {{
                    $t("public.components.organization.preferences.btnBilling")
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button v-if="checkPermissionProfessional('ORGANIZATION_PREFERENCES', [
                      'EDIT',
                    ])
                    " class="float-right mr-3" right variant="success" @click="updateOrganization">{{
      $t("public.components.organization.preferences.btnModify")
    }}
                </b-button>
              </template>
              <template v-slot:body>
                <h4 class="title-typography-color">
                  <i aria-hidden="true" class="fas fa-file-alt mr-2"></i>{{
                    $t(
                      "public.components.organization.preferences.organization.title"
                    )
                  }}
                </h4>
                <hr class="title-typography-color dot-typography" />
                <b-container fluid>
                  <b-button v-if="checkPermissionProfessional('ORGANIZATION_PREFERENCES', [
                        'EDIT',
                      ])
                      " hidden right variant="success">{{
      $t("public.components.organization.preferences.btnUpdate")
    }}
                  </b-button>

                  <div>
                    <b-form-group label-for="name">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.name"
                        )
                      }}:
                      </template>
                      <b-form-input id="name" v-model="name"></b-form-input>
                    </b-form-group>

                    <b-form-group label-for="document">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.document"
                        )
                      }}:
                      </template>
                      <b-form-input id="document" v-model="document"></b-form-input>
                    </b-form-group>

                    <b-form-group label-for="address">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.address"
                        )
                      }}:
                      </template>
                      <b-form-input id="address" v-model="address" :disabled="disabled" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="country">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.country"
                        )
                      }}:
                      </template>
                      <b-form-input id="country" v-model="country" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'country'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="province">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.province"
                        )
                      }}:
                      </template>
                      <b-form-input id="province" v-model="province" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'province'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="city">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.city"
                        )
                      }}:
                      </template>
                      <b-form-input id="city" v-model="city" type="text" v-bind:class="{
                        'text-danger': isFormCityErrors,
                        'is-invalid': isFormCityErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCityErrors">
                        <li v-for="(error, index) in validator.getErrors('city')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="postalCode">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.postalCode"
                        )
                      }}:
                      </template>
                      <b-form-input id="postalCode" v-model="postalCode" type="text" v-bind:class="{
                        'text-danger': isFormPostalCodeErrors,
                        'is-invalid': isFormPostalCodeErrors,
                      }"></b-form-input>
                      <ul v-if="isFormPostalCodeErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'postalCode'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="proformaInvoice">
                      <b-form-checkbox v-model="proformaInvoice" size="lg" switch><span>¿Quieres facturas
                          proforma?</span></b-form-checkbox>
                    </b-form-group>
                    <b-form-group label-for="prefixInvoiceNumber">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.prefixInvoiceNumber"
                        )
                      }}:
                      </template>
                      <b-form-input id="prefixInvoiceNumber" v-model="prefixInvoiceNumber" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="invoiceNumber">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.invoiceNumber"
                        )
                      }}:
                      </template>
                      <the-mask id="invoiceNumber" v-model="invoiceNumber" class="form-control" mask="###" type="text" />
                    </b-form-group>
                  </div>
                  <h4 class="title-typography-color">
                    <i aria-hidden="true" class="fas fa-money-bill-wave mr-2"></i>{{
                      $t(
                        "public.components.organization.preferences.organization.titlePaymentMode"
                      )
                    }}
                  </h4>
                  <hr class="title-typography-color dot-typography" />
                  <b-container>
                    <b-form-checkbox v-model="paymentModeWallet" size="lg" switch><span>Monedero</span></b-form-checkbox>
                    <b-form-checkbox v-model="paymentModeOutBefore" size="lg" switch><span>Pagar antes de la cita
                        (pasarela de pagos)</span></b-form-checkbox>
                    <b-form-checkbox v-model="paymentModeOutAfter" size="lg" switch><span>Pagar despues de la cita
                        (pasarela de pagos)</span></b-form-checkbox>
                    <b-form-checkbox v-model="paymentModeOutPlatform" size="lg" switch><span>No se requiere pago en la
                        plataforma o se
                        desconoce</span></b-form-checkbox>
                  </b-container>
                  <h4 class="title-typography-color">
                    <i aria-hidden="true" class="fas fa-money-bill-wave mr-2"></i>Pasarelas de pago
                  </h4>
                  <hr class="title-typography-color dot-typography" />
                  <b-container>
                    <b-form-checkbox v-model="paymentModePasarelaWallet" size="lg"
                      switch><span>Monedero</span></b-form-checkbox>
                    <b-form-checkbox v-model="paymentModePasarelaStripe" size="lg"
                      switch><span>Stripe</span></b-form-checkbox>
                    <div v-if="paymentModePasarelaStripe">
                      <b-alert v-if="stripeValidate === true" show variant="success">
                        {{
                          $t(
                            "public.components.organization.preferences.preferences.payments.stripeValidated"
                          )
                        }}
                      </b-alert>
                      <b-alert v-else show variant="danger">
                        {{
                          $t(
                            "public.components.organization.preferences.preferences.payments.validateAcount"
                          )
                        }}
                      </b-alert>
                      <b-row cols="9">
                        <b-col>
                          <b-input-group class="mb-3" prepend="Stripe" size="sm">
                            <b-form-input v-model="stripeApi" :disabled="stripeValidate === true"
                              placeholder="Api"></b-form-input>
                            <b-form-input v-model="stripePublic" :disabled="stripeValidate === true"
                              placeholder="Public"></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="stripeValidate === true" size="sm" text="Button" variant="success"
                                @click="validateStripeOrganization">
                                {{
                                  $t(
                                    "public.components.organization.preferences.preferences.payments.btnValidate"
                                  )
                                }}
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-button v-if="checkPermissionProfessional(
                                'ORGANIZATION_PREFERENCES',
                                ['EDIT']
                              )
                              " class="float-right" href="https://stripe.com/docs/keys" variant="primary">
                            {{
                              $t(
                                "public.components.organization.preferences.preferences.payments.stripeInfo"
                              )
                            }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                    <b-form-checkbox v-model="paymentModePasarelaPaypal" size="lg"
                      switch><span>Paypal</span></b-form-checkbox>
                    <div v-if="paymentModePasarelaPaypal">
                      <b-row>
                        <b-col>
                          <b-alert v-if="paypalValidate === true" show variant="success">
                            {{
                              $t(
                                "public.components.organization.preferences.preferences.payments.paypalValidated"
                              )
                            }}
                          </b-alert>
                          <b-alert v-else show variant="danger">
                            {{
                              $t(
                                "public.components.organization.preferences.preferences.payments.validatePaypal"
                              )
                            }}
                          </b-alert>
                        </b-col>
                      </b-row>
                      <b-row cols="9">
                        <b-col>
                          <b-input-group class="mb-3" prepend="Paypal" size="sm">
                            <b-form-input v-model="paypalClientId" :disabled="paypalValidate === true"
                              placeholder="Client Id"></b-form-input>
                            <b-form-input v-model="paypalSecret" :disabled="paypalValidate === true"
                              placeholder="Secret"></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="paypalValidate === true" size="sm" text="Button" variant="success"
                                @click="validatePaypalOrganization">
                                {{
                                  $t(
                                    "public.components.organization.preferences.preferences.payments.btnValidate"
                                  )
                                }}
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-button class="float-right" href="https://developer.paypal.com/home" variant="primary">
                            {{
                              $t(
                                "public.components.organization.preferences.preferences.payments.paypalInfo"
                              )
                            }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </b-container>
                  <h4 class="title-typography-color">
                    <i aria-hidden="true" class="fas fa-money-bill-wave mr-2"></i>{{
                      $t(
                        "public.components.organization.preferences.organization.titlePaymentOutPlataform"
                      )
                    }}
                  </h4>
                  <hr class="title-typography-color dot-typography" />
                  <div>
                    <div class="text-right">
                      <b-button v-if="checkPermissionProfessional(
                            'ORGANIZATION_PREFERENCES',
                            ['EDIT']
                          )
                          " class="mb-3 mr-1" variant="success" @click="openModalCreatePaymentOutPlataform">
                        {{
                          $t(
                            "public.components.organization.preferences.preferences.paymentOutPlataform.btnCreate"
                          )
                        }}
                      </b-button>
                    </div>
                    <v-data-table :footer-props="{
                          showFirstLastPage: true,
                          firstIcon: 'fas fa-arrow-left',
                          lastIcon: 'fas fa-arrow-right',
                          prevIcon: 'fas fa-minus',
                          nextIcon: 'fas fa-plus',
                          'items-per-page-options': [10, 25, 50],
                        }" :headers="headers" :items="paymentOutPlataforms" item-key="id">
                      <template v-slot:item.active="{ item }">
                        <b-form-checkbox v-model="item.active" size="lg" switch @input="
                          savePaymentOutPlataformActive(item.id, item.active)
                          "></b-form-checkbox>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <div v-if="!item.defaultItem" class="div-table-data">
                          <button v-if="checkPermissionProfessional(
                            'ORGANIZATION_PREFERENCES',
                            ['EDIT']
                          )
                            " :id="'btnDeletePayment' + item.id" class="item" type="button"
                            @click.stop="deletePaymentOutPlataform(item.id)">
                            <i class="ri-delete-bin-line"></i>
                          </button>
                          <b-popover v-if="checkPermissionProfessional(
                            'ORGANIZATION_PREFERENCES',
                            ['EDIT']
                          )
                            " :target="'btnDeletePayment' + item.id" placement="botton" triggers="hover focus">
                            <template #title>{{
                              $t(
                                "public.components.organization.preferences.preferences.paymentOutPlataform.btnDelete"
                              )
                            }}
                            </template>
                          </b-popover>
                        </div>
                      </template>
                    </v-data-table>
                    <b-modal id="modal-payment-out-plataform" centered @ok="saveFormCreatePaymentOutPlataform">
                      <template #modal-cancel>{{
                        $t(
                          "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.btnCancel"
                        )
                      }}
                      </template>
                      <template #modal-ok>{{
                        $t(
                          "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.btnCreate"
                        )
                      }}
                      </template>
                      <template #modal-title>
                        {{
                          $t(
                            "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.title"
                          )
                        }}
                      </template>
                      <b-form-group label-for="paymentOutPlataform.name">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.name"
                          )
                        }}: *
                        </template>
                        <b-form-input v-model="paymentOutPlataform.name" type="text" v-bind:class="{
                          'text-danger': isFormPaymentOutPlataformNameErrors,
                          'is-invalid': isFormPaymentOutPlataformNameErrors,
                        }" @blur="
  checkPaymentOutPlataformName(
    paymentOutPlataform.name
  )
  "></b-form-input>
                        <ul v-if="isFormPaymentOutPlataformNameErrors">
                          <li v-for="(error, index) in validator2.getErrors(
                            'paymentOutPlataform.name'
                          )" v-bind:key="index" class="form-text text-danger">
                            &nbsp;{{ error }}
                          </li>
                        </ul>
                      </b-form-group>
                    </b-modal>
                  </div>
                  <b-row>
                    *{{
                      $t("public.components.organization.preferences.required")
                    }}
                  </b-row>
                </b-container>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item id="preferences-preferences-tab" :active="false">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="fas fa-cogs"></i>
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.title"
                    )
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button v-if="checkPermissionProfessional('ORGANIZATION_PREFERENCES', [
                      'EDIT',
                    ])
                    " class="float-right mr-3" right variant="success" @click="updateOrganization">{{
      $t("public.components.organization.preferences.btnModify")
    }}
                </b-button>
              </template>
              <template v-slot:body>
                <b-container fluid>
                  <b-form>
                    <div>
                      <b-form-group label-for="currency">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.preferences.currency"
                          )
                        }}:
                        </template>
                        <b-select id="currency" v-model="currency" :options="currencySelect" class="form-control">
                        </b-select>
                      </b-form-group>
                      <b-form-group label-for="language">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.preferences.mainLanguage"
                          )
                        }}:
                        </template>
                        <b-select id="language" v-model="language" :options="languageSelect" class="form-control">
                        </b-select>
                      </b-form-group>
                      <b-form-group label-for="timeZone">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.preferences.timeZone"
                          )
                        }}:
                        </template>
                        <b-select id="timeZone" v-model="timeZone" :options="timeZoneSelect" class="form-control">
                        </b-select>
                      </b-form-group>
                      <b-form-group label-for="previousTime">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.preferences.previousTime"
                          )
                        }}:
                        </template>
                        <the-mask id="previousTime" v-model="previousTime" class="form-control" mask="###" type="text" />
                      </b-form-group>
                    </div>
                    <b-form-group label-for="phone">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.organization.tlf"
                        )
                      }}:
                      </template>
                      <VuePhoneNumberInput id="phone" v-model="phoneVuePhoneNumberInput" :translations="translations"
                        v-bind:class="{
                          'text-danger': isFormPhoneErrors,
                          'is-invalid': isFormPhoneErrors,
                        }" @update="updatePhone" />
                      {{ phone }}
                      <ul v-if="isFormPhoneErrors">
                        <li v-for="(error, index) in validator.getErrors('phone')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>

                    <b-form-group label-for="email">
                      <template slot="label">{{
                        $t(
                          "public.components.organization.preferences.preferences.email"
                        )
                      }}:
                      </template>
                      <b-form-input id="email" v-model="email" type="text"></b-form-input>
                    </b-form-group>
                    <div>
                      <b-form-group label-for="cancellationAppoiments">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.preferences.cancelation"
                          )
                        }}:
                        </template>
                        <b-form-radio-group id="cancellationAppoiments" v-model="cancellationAppoiments"
                          aria-controls="cancellationAppoiments">
                          <b-form-radio value="true">{{
                            $t("public.components.organization.preferences.yes")
                          }}
                          </b-form-radio>
                          <b-form-radio value="false">{{
                            $t("public.components.organization.preferences.no")
                          }}
                          </b-form-radio>
                        </b-form-radio-group>
                  <!--      <b-form-group label-for="cancellationAppoimentsTime">
                          <template slot="label">{{
                            $t(
                              "public.components.organization.preferences.preferences.adviseTime"
                            )
                          }}:
                          </template>
                          <the-mask id="cancellationAppoimentsTime" v-model="cancellationAppoimentsTime"
                            class="form-control" mask="###" type="text" />
                        </b-form-group> -->
                      </b-form-group> 
                    </div>
                    <b-row>
                      *{{
                        $t(
                          "public.components.organization.preferences.required"
                        )
                      }}
                    </b-row>
                  </b-form>
                </b-container>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item id="preferences-customize-tab" :active="false">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="fas fa-magic"></i>
                  {{
                    $t(
                      "public.components.organization.preferences.customize.title"
                    )
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button v-if="checkPermissionProfessional('ORGANIZATION_PREFERENCES', [
                      'EDIT',
                    ])
                    " class="float-right mr-3" right variant="success" @click="updateOrganization">{{
      $t("public.components.organization.preferences.btnModify")
    }}
                </b-button>
              </template>
              <template v-slot:body>
                <b-container fluid>
                  <b-form>
                    <div>
                      <b-form-group label-for="tradename">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.name"
                          )
                        }}:
                        </template>
                        <b-form-input id="tradename" v-model="tradename" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group label-for="webAddress">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.url"
                          )
                        }}:
                        </template>
                        <b-input-group class="mb-3" size="sm">
                          <b-form-input id="webAddress" v-model="webAddress" class="borde-right-0"
                            type="text"></b-form-input>
                          <b-input-group-append class="border borde-left-0">
                            <span class="ml-1 mr-1">.cita.io</span>
                            <b-button size="sm" text="Button" variant="primary" @click="onCopy">Copiar
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>

                        <p>
                          <template slot="label">{{
                            $t(
                              "public.components.organization.preferences.customize.urlCondition"
                            )
                          }}
                          </template>
                        </p>
                      </b-form-group>
                      <b-form-group label-for="pictureLogo">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.image"
                          )
                        }}:
                        </template>
                        <div class="row">
                          <div class="col-md-8">
                            <vue-dropzone id="picture" :options="dropzoneOptions"
                              @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
                          </div>
                          <div class="col-md-4 img-center">
                            <img v-if="defaultAvatar" :src="file" class="img-fluid rounded mr-3" height="150px"
                              width="150px" />
                            <img v-else class="img-fluid rounded mr-3" height="150px"
                              v-bind:src="'data:image/jpeg;base64,' + file" width="150px" />
                          </div>
                        </div>
                      </b-form-group>

                      <p>
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.imageCondition"
                          )
                        }}
                        </template>
                      </p>
                      <b-form-group label-for="welcomeMessage">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.message"
                          )
                        }}:
                        </template>
                        <b-form-textarea id="welcomeMessage" v-model="welcomeMessage" size="lg"></b-form-textarea>
                      </b-form-group>
                      <b-form-group label-for="copyright">
                        <template slot="label">Copyright:
                        </template>
                        <b-form-input id="copyright" v-model="copyright" type="text"></b-form-input>
                      </b-form-group>
                    </div>
                    <br />
                    <h4 class="title-typography-color">
                      <i aria-hidden="true" class="fa fa-folder-open"></i>Básico
                    </h4>
                    <hr class="title-typography-color dot-typography" />
                    <div>
                      <b-form-group label-for="colorMenu">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.colorMenu"
                          )
                        }}:
                        </template>
                        <b-form-input id="colorMenu" v-model="colorMenu" type="color"
                          @change="changeColor"></b-form-input>
                      </b-form-group>
                      <b-form-group label-for="colorTypography">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.colorTypography"
                          )
                        }}:
                        </template>
                        <b-form-input id="colorTypography" v-model="colorTypography" type="color"
                          @change="changeColor"></b-form-input>
                      </b-form-group>
                      <b-form-group label-for="colorWallpaper">
                        <template slot="label">{{
                          $t(
                            "public.components.organization.preferences.customize.colorWallpaper"
                          )
                        }}:
                        </template>
                        <b-form-input id="colorWallpaper" v-model="colorWallpaper" type="color"
                          @change="changeColor"></b-form-input>
                      </b-form-group>
                    </div>
                    <div align="center">
                      <b-button v-if="checkPermissionProfessional(
                        'ORGANIZATION_PREFERENCES',
                        ['EDIT']
                      )
                        " @click="resetDefaultValue">{{
    $t(
      "public.components.organization.preferences.customize.btnReset"
    )
  }}
                      </b-button>
                    </div>
                    <h4 class="title-typography-color">
                      <i aria-hidden="true" class="fa fa-folder-open"></i>{{
                        $t(
                          "public.components.organization.preferences.customize.advanced"
                        )
                      }}
                    </h4>
                    <hr class="title-typography-color dot-typography" />
                    <b-form-group label-for="pictureLogo">
                      <template slot="label">Spinner: imagen o animación (GIF) que aparecerá mientras el sistema devuelve una respuesta a su petición:
                      </template>
                      <div class="row">
                        <div class="col-md-8">
                          <vue-dropzone id="picture" :options="dropzoneOptions"
                            @vdropzone-success="vdropzoneSuccessSpinner"></vue-dropzone>
                        </div>
                        <div class="col-md-4 img-center">
                          <img v-if="defaultSpinner" :src="fileSpinner" class="img-fluid rounded mr-3" height="150px"
                            width="150px" />
                          <img v-else class="img-fluid rounded mr-3" height="150px"
                            v-bind:src="'data:image/jpeg;base64,' + fileSpinner" width="150px" />
                        </div>
                      </div>
                    </b-form-group>
                    <b-row>
                      *{{
                        $t(
                          "public.components.organization.preferences.required"
                        )
                      }}
                    </b-row>
                  </b-form>
                </b-container>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item v-if="role === 'ADMIN'" id="preferences-account-tab" :active="false">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                  {{
                    $t(
                      "public.components.organization.preferences.account.title"
                    )
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button v-if="checkPermissionProfessional('ORGANIZATION_PREFERENCES', [
                      'EDIT',
                    ])
                    " class="float-right mr-3" right variant="success" @click="updateOrganization">{{
      $t("public.components.organization.preferences.btnModify")
    }}
                </b-button>
              </template>
              <template v-if="account" v-slot:body>
                 <PreferencesAccount :accountId="account.id" :planType="account.planType"></PreferencesAccount> 
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item v-if="superUser" id="preferences-template-tab" :active="false">
            <PreferencesTemplates :organization="organization"></PreferencesTemplates>
          </tab-content-item>
          <tab-content-item v-if="superUser" id="preferences-email-tab" :active="false">
            <PreferencesEmail :organization="organization"></PreferencesEmail>
          </tab-content-item>
          <tab-content-item v-if="superUser" id="preferences-footer-tab" :active="false">
            <PreferencesFooter :organization="organization"></PreferencesFooter>
          </tab-content-item>
          <tab-content-item v-if="superUser" id="preferences-superuser-tab" :active="false">
            <PreferencesAdmin :organization="organization" :planType="account.planType"></PreferencesAdmin>
          </tab-content-item>
        </tab-content>
      </b-col>
    </b-row>

    <b-modal id="modal-account-charge" centered size="sm" @ok="saveFormStep1">
      <template #modal-title>{{
        $t("public.components.organization.preferences.account.modal.title")
      }}
      </template>
      <template #modal-ok>{{
        $t("public.components.organization.preferences.account.modal.save")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.components.organization.preferences.account.modal.close")
      }}
      </template>
      <form action="#">
        <b-form-group label-for="type">
          <template slot="label">{{
            $t(
              "public.components.organization.preferences.account.modal.type"
            )
          }}: *
          </template>
          <b-select v-model="type" :disabled="disabled" :options="typeSelect" v-bind:class="{
            'text-danger': isFormTypeErrors,
            'is-invalid': isFormTypeErrors,
          }" @blur="checkType(type)" @change="updateTotalService"></b-select>
          <ul v-if="isFormTypeErrors">
            <li v-for="(error, index) in validator1.getErrors('type')" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="quantity">
          <template slot="label">{{
            $t(
              "public.components.organization.preferences.account.modal.quantity"
            )
          }}: *
          </template>
          <b-select v-model="quantity" :disabled="disabled" :options="quantitySelect" v-bind:class="{
            'text-danger': isFormQuantityErrors,
            'is-invalid': isFormQuantityErrors,
          }" @blur="checkQuatity(type)" @change="updateTotalService"></b-select>
          <ul v-if="isFormQuantityErrors">
            <li v-for="(error, index) in validator1.getErrors('quantity')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        {{
          $t("public.components.organization.preferences.account.modal.total")
        }}
        {{ totalService }} €
      </form>
    </b-modal>

    <b-modal id="modal-invoice-info" centered hide-footer size="xl">
      <template #modal-title>{{
        $t(
          "public.components.organization.preferences.preferences.modalInvoiceInfo.title"
        )
      }}
      </template>
      <form action="#">
        <b-container>
          <b-row>
            <b-col cols="6">
              <b-form-group v-if="numberInvoiceInfo" label-for="numberInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.invoiceNumber"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">{{ numberInvoiceInfo }}</li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group v-if="conceptInvoiceInfo" label-for="conceptInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.concept"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">{{ conceptInvoiceInfo }}</li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group v-if="monthInvoiceInfo" label-for="monthInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.month"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">{{ monthInvoiceInfo }}</li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group v-if="yearInvoiceInfo" label-for="monthInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.year"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">{{ yearInvoiceInfo }}</li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-for="totalInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.total"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">{{ totalInvoiceInfo }} €</li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group v-if="dateInvoiceInfo" label-for="totalInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.date"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">{{ dateInvoiceInfo }}</li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group v-if="sellerInvoiceInfo" label-for="sellerInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.seller"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="sellerInvoiceInfo.name" class="list-group-item">
                    {{ sellerInvoiceInfo.name }}
                  </li>
                  <li v-if="sellerInvoiceInfo.lastname" class="list-group-item">
                    {{ sellerInvoiceInfo.lastname }}
                  </li>
                  <li v-if="sellerInvoiceInfo.document" class="list-group-item">
                    {{ sellerInvoiceInfo.document }}
                  </li>
                  <li v-if="sellerInvoiceInfo.address" class="list-group-item">
                    {{ sellerInvoiceInfo.address }}
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group v-if="buyerInvoiceInfo" label-for="buyerInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.buyer"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="buyerInvoiceInfo.name" class="list-group-item">
                    {{ buyerInvoiceInfo.name }}
                  </li>
                  <li v-if="buyerInvoiceInfo.lastname" class="list-group-item">
                    {{ buyerInvoiceInfo.lastname }}
                  </li>
                  <li v-if="buyerInvoiceInfo.document" class="list-group-item">
                    {{ buyerInvoiceInfo.document }}
                  </li>
                  <li v-if="buyerInvoiceInfo.address" class="list-group-item">
                    {{ buyerInvoiceInfo.address }}
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group v-if="itemsInvoiceInfo" label-for="itemsInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.services"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-for="(item, index) in itemsInvoiceInfo" :key="index" class="list-group-item">
                    {{ item.description }} - {{ item.subtotal.toFixed(2) }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group v-if="billingInvoiceInfo" label-for="billingInvoiceInfo">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalInvoiceInfo.charge"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">
                    <b-badge v-if="totalInvoiceInfo === 0" class="text-uppercase" pill variant="warning">
                      {{
                        $t(
                          "public.components.organization.preferences.preferences.modalInvoiceInfo.includedOnPlan"
                        )
                      }}
                    </b-badge>
                    <b-badge v-else-if="billingInvoiceInfo.payment &&
                        billingInvoiceInfo.payment.paymentStatus ===
                        'PENDING' &&
                        billingInvoiceInfo.payment.paymentMode ===
                        'BANK_TRANSFER'
                        " class="text-uppercase" pill variant="success">
                      {{
                        $t(
                          "public.components.organization.preferences.preferences.modalInvoiceInfo.unvalidated"
                        )
                      }}
                      ({{ billingInvoiceInfo.payment.bankAccount }})
                    </b-badge>
                    <b-badge v-else-if="billingInvoiceInfo.payment &&
                      billingInvoiceInfo.payment.paymentStatus === 'SUCCESS'
                      " class="text-uppercase" pill variant="success">
                      {{
                        $t(
                          "public.components.organization.preferences.preferences.modalInvoiceInfo.paid"
                        )
                      }}
                      -
                      <span v-if="billingInvoiceInfo.payment.bankAccount">{{
                        $t(
                          "public.components.organization.preferences.preferences.modalInvoiceInfo.account"
                        )
                      }}: {{ billingInvoiceInfo.payment.bankAccount }}</span>
                      <span v-else-if="billingInvoiceInfo.payment.paypalPayment">{{
                        $t(
                          "public.components.preferences.preferences.modalInvoiceInfo.paypalTransaction"
                        )
                      }}: {{ billingInvoiceInfo.payment.paypalPayment }}</span>
                      <span v-else-if="billingInvoiceInfo.payment.stripeSession">{{
                        $t(
                          "public.components.organization.preferences.preferences.modalInvoiceInfo.stripeTransaction"
                        )
                      }}: {{ billingInvoiceInfo.payment.stripeSession }}</span>
                    </b-badge>

                    <b-badge v-else-if="billingInvoiceInfo.payment &&
                      billingInvoiceInfo.payment.paymentStatus === 'PENDING'
                      " class="text-uppercase" pill variant="danger">
                      {{
                        $t(
                          "public.components.organization.preferences.preferences.modalInvoiceInfo.pending"
                        )
                      }}
                    </b-badge>
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
      </form>
    </b-modal>
    <b-modal id="modal-pay" centered hide-footer size="sm">
      <template #modal-title>{{
        $t(
          "public.components.organization.preferences.preferences.modalPay.title"
        )
      }}
      </template>
      <template #modal-cancel>{{
        $t(
          "public.components.organization.preferences.preferences.modalPay.cancel"
        )
      }}
      </template>
      <div class="payment-btn-center">
        <i id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPaymentInvoice"></i>
        <b-popover :target="'btnPaypal'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t(
              "public.components.organization.preferences.preferences.modalPay.paypalPay"
            )
          }}
          </template>
        </b-popover>
        <i id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePaymentInvoice"></i>
        <b-popover :target="'btnStripe'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t(
              "public.components.organization.preferences.preferences.modalPay.paypalStripe"
            )
          }}
          </template>
        </b-popover>
      </div>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>

<script>
import { xray } from "../../config/pluginInit";

import Currency from "../../json/Currency";
import TimeZone from "../../services/timeZone";
import Language from "../../json/Language";
import ReleaseServiceQuantity from "../../json/ReleaseServiceQuantity";
import ReleaseService from "../../json/ReleaseService";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import validator from "vue-m-validator";
import StripeCheckout from "@vue-stripe/vue-stripe";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import organizationService from "../../services/organization";
import utilsService from "../../services/utils";
import accountService from "../../services/account";
import invoiceService from "../../services/invoice";

import PreferencesAccount from "../../components/organization/PreferencesAccount";

import PreferencesAdmin from "../../components/organization/PreferencesAdmin";

import PreferencesTemplates from "../../components/organization/PreferencesTemplates";
import PreferencesFooter from "../../components/organization/PreferencesFooter";
import PreferencesEmail from "../../components/organization/PreferencesEmail";

export default {
  name: "OrganizationPreference",
  props: {
    organizationId: {},
  },
  mounted() {
    xray.index();
    this.verifyPay();
    this.getOrganization();
    this.getAllPaymentOutPlataform();
  },
  methods: {
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    onCopy() {
      if (this.webAddress) {
        let url = "https://" + this.webAddress + ".cita.io";
        this.$clipboard(url);
        this.$notify({
          group: "notificacions",
          title: "Éxito",
          text:
            "Se ha copiado al portapapeles: <a href='" +
            url +
            "'>" +
            url +
            "</a>",
          type: "success",
        });
      } else {
        this.$notify({
          group: "notificacions",
          title: "Error",
          text: "Tiene que tener un nombre válido",
          type: "error",
        });
      }
    },
    payInvoice(id) {
      this.idInvoicePay = id;
      this.$bvModal.show("modal-pay");
    },
    getDateHistory(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    resetDefaultValue() {
      // Advanced preferences
      this.previousTime = 0;
      this.currency = "EUR";
      this.proformaInvoice = false;
      this.cancellationAppoiments = false;
      this.cancellationAppoimentsTime = 0;
      this.remindersSms = false;
      this.remindersWhatApp = false;
      this.remindersPhone = false;

      // Personalization
      this.welcomeMessage = "";
      this.spinner = "";
      this.copyright = "";
      this.colorMenu = "#ffffff";
      this.colorTypography = "#089bab";
      this.colorWallpaper = "#eff7f8";
      this.fileSpinner = require("../../assets/images/loader.gif");
      this.defaultSpinner = true;

      this.changeColor();
    },
    changeColor() {
      //Update menu color
      document.documentElement.style.setProperty("--navbar", this.colorMenu);
      //Update typography color
      document.documentElement.style.setProperty(
        "--typography",
        this.colorTypography
      );
      //Update navbar color
      document.documentElement.style.setProperty(
        "--wallpaper",
        this.colorWallpaper
      );
    },
    validatePaypalOrganization() {
      let self = this;

      if (!this.paypalClientId || !this.paypalSecret) {
        self.$swal(
          this.$i18n.t(
            "public.components.organization.preferences.preferences.paypalClientIdText"
          ),
          this.$i18n.t(
            "public.components.organization.preferences.preferences.paypalClientIdText1"
          ),
          this.$i18n.t(
            "public.components.organization.preferences.preferences.modalPay.stripeApiText3"
          )
        );
      } else {
        let data = {
          paypalClientId: this.paypalClientId,
          paypalSecret: this.paypalSecret,
        };

        this.$awn.asyncBlock(
          organizationService.checkPaypal(
            localStorage.getItem("organizationId"),
            data
          ),
          (response) => {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            self.getOrganization();
            self.$swal(
              this.$i18n.t(
                "public.components.organization.preferences.preferences.paypalClientIdText2"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.paypalClientIdText3"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.modalPay.stripeApiText2"
              )
            );
          },
          (error) => {
            self.paypalClientId = "";
            self.paypalSecret = "";
            self.$swal(
              this.$i18n.t(
                "public.components.organization.preferences.preferences.paypalClientIdText"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.paypalClientIdText1"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.modalPay.stripeApiText3"
              )
            );
          },
          " "
        );
      }
    },
    validateStripeOrganization() {
      let self = this;

      if (!this.stripeApi || !this.stripePublic) {
        self.$swal(
          this.$i18n.t(
            "public.components.organization.preferences.preferences.stripeApiText4"
          ),
          this.$i18n.t(
            "public.components.organization.preferences.preferences.stripeApiText5"
          ),
          this.$i18n.t(
            "public.components.organization.preferences.preferences.stripeApiText3"
          )
        );
      } else {
        let data = {
          stripeApi: this.stripeApi,
          stripePublic: this.stripePublic,
        };

        this.$awn.asyncBlock(
          organizationService.checkStripe(
            localStorage.getItem("organizationId"),
            data
          ),
          (response) => {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            self.getOrganization();
            self.$swal(
              this.$i18n.t(
                "public.components.organization.preferences.preferences.stripeApiText"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.stripeApiText1"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.stripeApiText2"
              )
            );
          },
          (error) => {
            self.stripeApi = "";
            self.stripePublic = "";
            self.$swal(
              this.$i18n.t(
                "public.components.organization.preferences.preferences.stripeApiText4"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.stripeApiText5"
              ),
              this.$i18n.t(
                "public.components.organization.preferences.preferences.stripeApiText3"
              )
            );
          },
          " "
        );
      }
    },
    // Pay
    verifyPay() {
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined &&
        this.$route.query.paymentId !== undefined &&
        this.$route.query.invoiceCitaId !== undefined &&
        this.$route.query.PayerID !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccessInvoiceCita(
            this.$route.query.invoiceCitaId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      } else {
        if (
          this.$route.query.action !== undefined &&
          this.$route.query.mode !== undefined &&
          this.$route.query.tokenback !== undefined &&
          this.$route.query.token !== undefined &&
          this.$route.query.invoiceCitaId !== undefined
        ) {
          if (this.$route.query.action === "cancel") {
            let data = {
              tokenPaypal: this.$route.query.token,
              paymentIdPaypal: this.$route.query.paymentId,
              payerIDPaypal: this.$route.query.PayerID,
            };

            this.payCancelInvoiceCita(
              this.$route.query.invoiceCitaId,
              this.$route.query.mode,
              this.$route.query.tokenback,
              data
            );
          }
        } else {
          if (
            this.$route.query.action !== undefined &&
            this.$route.query.mode !== undefined &&
            this.$route.query.tokenback !== undefined &&
            this.$route.query.invoiceCitaId !== undefined
          ) {
            if (this.$route.query.action === "success") {
              let data = {
                tokenPaypal: "",
                paymentIdPaypal: "",
                payerIDPaypal: "",
              };

              this.paySuccessInvoiceCita(
                this.$route.query.invoiceCitaId,
                this.$route.query.mode,
                this.$route.query.tokenback,
                data
              );
            }
            if (this.$route.query.action === "cancel") {
              let data = {
                tokenPaypal: "",
                paymentIdPaypal: "",
                payerIDPaypal: "",
              };

              this.payCancelInvoiceCita(
                this.$route.query.invoiceCitaId,
                this.$route.query.mode,
                this.$route.query.tokenback,
                data
              );
            }
          }
        }
      }
    },
    showStripePaymentInvoice() {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.payStripeInvoiceCita(this.idInvoicePay),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.payStripeInvoiceCita",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idInvoicePay: this.idInvoicePay
            }),
          });
        },
        " "
      );
    },
    showPaypalPaymentInvoice() {
      let self = this;

      let data = {
        organizationId: this.id,
      };

      this.$awn.asyncBlock(
        invoiceService.payPaypalInvoiceCita(this.idInvoicePay),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.payPaypalInvoiceCita",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idInvoicePay: this.idInvoicePay
            }),
          });
        },
        " "
      );
    },
    paySuccessInvoiceCita(id, mode, token, data) {
      let self = this;

      invoiceService
        .paySuccess(id, mode, token, data)
        .then((response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
          self.findAllInvoicesCitaById();
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.preferences.success.pay.title"
            ),
            text: this.$i18n.t(
              "public.components.organization.preferences.success.pay.text"
            ),
            type: "success",
          });
        })
        .error((error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.paySuccess",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, mode: mode, token: token, data: data
            }),
          });
        });
    },
    payCancelInvoiceCita(id, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.payCancel(id, mode, token, data),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
          self.findAllInvoicesCitaById();
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.preferences.error.pay.title"
            ),
            text: this.$i18n.t(
              "public.components.organization.preferences.error.pay.text"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.payCancel",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, mode: mode, token: token, data: data
            }),
          });
        },
        " "
      );
    },
    paySuccess(id, mode, token) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.paySuccess(id, mode, token),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.preferences.success.pay.title"
            ),
            text: this.$i18n.t(
              "public.components.organization.preferences.success.pay.text"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.paySuccess",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, mode: mode, token: token
            }),
          });
        },
        " "
      );
    },
    payCancel(mode, token) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payCancel(id, mode, token),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.preferences.error.pay.title"
            ),
            text: this.$i18n.t(
              "public.components.organization.preferences.error.pay.text"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCancel",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, mode: mode, token: token
            }),
          });
        },
        " "
      );
    },
    // Account
    showCharge() {
      this.$bvModal.show("modal-account-charge");
    },
    updateTotalService() {
      if (this.type && this.quantity) {
        if (this.type === "TWILIO_SMS") {
          this.totalService =
            this.accountHistory.planType.priceMessageSms * this.quantity;
        }
        if (this.type === "TWILIO_WHATSAPP") {
          this.totalService =
            this.accountHistory.planType.priceMessageWhatapp * this.quantity;
        }
        if (this.type === "TWILIO_PHONE") {
          this.totalService =
            this.accountHistory.planType.priceCallPhone * this.quantity;
        }
      }
    },
    recharge() {
      let self = this;

      let data = {
        quantity: this.quantity,
        type: this.type,
      };

      this.$awn.asyncBlock(
        accountService.recharge(this.accountId, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            self.account = response.data;
            self.$bvModal.hide("modal-account-charge");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.account.modal.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.account.modal.success.text"
              ),
              type: "success",
            });
            self.getOrganization();
            self.findAllInvoicesCitaById();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "accountService.recharge",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              accountId: this.accountId, data: data
            }),
          });
        },
        " "
      );
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validator1.errors.length === 0) {
        //Call service to store data
        this.recharge();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.organization.preferences.account.modal.errors.title"
          ),
          text: this.$i18n.t(
            "public.components.organization.preferences.account.modal.errors.text"
          ),
          type: "error",
        });
      }
    },
    checkFormStep1() {
      this.checkType(this.type);
      this.checkQuantity(this.quantity);
    },
    checkFormStep2() {
      this.checkPaymentOutPlataformName(this.paymentOutPlataform.name);
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkType(_type) {
      const TYPE = _type;
      const RULE_1 = {
        expression: !TYPE || TYPE === "",
        name: "type",
        msg: this.$i18n.t(
          "public.components.organization.preferences.account.modal.errors.type"
        ),
      };
      this.validator1.addRule(RULE_1);
      this.notFirst();
    },
    checkQuantity(_quantity) {
      const QUANTITY = _quantity;
      const RULE_1 = {
        expression: !QUANTITY || QUANTITY === "",
        name: "quantity",
        msg: this.$i18n.t(
          "public.components.organization.preferences.account.modal.errors.quantity"
        ),
      };
      this.validator1.addRule(RULE_1);
      this.notFirst();
    },
    getSpinner(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultSpinner = false;
            self.fileSpinner = response.data.data;
          } else {
            self.defaultSpinner = true;
            self.fileSpinner = require("../../assets/images/loader.gif");
          }
        })
        .catch(function (error) {
          self.defaultSpinner = true;
          self.fileSpinner = require("../../assets/images/loader.gif");
        });
    },
    getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../assets/images/logo.png");
        });
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erDocument"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkPhone(_phone) {
      const PHONE = _phone.trim();
      const RULE_1 = {
        expression: !PHONE || PHONE === "",
        name: "phone",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erTlf"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkEmail(_email) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erEmail1"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        '^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))'
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erEmail2"
        ),
      };
      validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erCountry"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkProvince(_province) {
      const PROVINCE = _province.trim();
      const RULE_1 = {
        expression: !PROVINCE || PROVINCE === "",
        name: "province",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erProvince"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkAddress(_address) {
      const ADDRESS = _address.trim();
      const RULE_1 = {
        expression: !ADDRESS || ADDRESS === "",
        name: "address",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erAdress"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkCity(_city) {
      const CITY = _city.trim();
      const RULE_1 = {
        expression: !CITY || CITY === "",
        name: "city",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erCity"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkPostalCode(_postalCode) {
      const POSTALCODE = _postalCode.trim();
      const RULE_1 = {
        expression: !POSTALCODE || POSTALCODE === "",
        name: "postalCode",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erPostalCode"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkBankAccount(_bankAccount) {
      const BANKACCOUNT = _bankAccount.trim();
      const RULE_1 = {
        expression: !BANKACCOUNT || BANKACCOUNT === "",
        name: "bankAccount",
        msg: this.$i18n.t(
          "public.components.organization.preferences.errors.erBankAccount"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },

    checkPaymentOutPlataformName(_paymentOutPlataformName) {
      const PAYMENTOUTPLATAFORMNAME = _paymentOutPlataformName.trim();
      const RULE_1 = {
        expression: !PAYMENTOUTPLATAFORMNAME || PAYMENTOUTPLATAFORMNAME === "",
        name: "paymentOutPlataform.name",
        msg: this.$i18n.t(
          "public.components.organization.preferences.paymentOutPlataform.modalCreate.errors.erPaymentOutPlataformName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },

    checkForm() {
      //this.checkName(this.name);
      //  this.checkPhone(this.phone);
      //this.checkEmail(this.email);
      // this.checkCountry(this.country);
      // this.checkProvince(this.province);
      // this.checkAddress(this.address);
      // this.checkCity(this.city);
      // this.checkPostalCode(this.postalCode);
      // this.checkBankAccount(this.bankAccount);
    },

    selectDiv(selected) {
      this.variableDiv = selected;
    },
    vdropzoneSuccessSpinner: function (file, response) {
      this.spinner = response.uuid;

      this.getSpinner(this.spinner);
    },
    vdropzoneSuccess: function (file, response) {
      this.logo = response.uuid;

      this.getLogo(this.logo);
    },
    updateForm(evt) {
      evt.preventDefault();
      this.checkForm();
      if (this.validator.errors.length === 0) {
        //Call service to store data
        this.updateOrganization();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.organization.preferences.errors.erTitle"
          ),
          text: this.$i18n.t(
            "public.components.organization.preferences.errors.erStep1"
          ),
          type: "error",
        });
      }
    },
    updateOrganization() {
      let self = this;

      var data = {
        id: this.id,
        email: this.email,
        name: this.name,
        document: this.document,
        address: this.address,
        country: this.country,
        city: this.city,
        postalCode: this.postalCode,
        prefixInvoiceNumber: this.prefixInvoiceNumber,
        invoiceNumber: this.invoiceNumber,
        prefixRectifyNumber: this.prefixRectifyNumber,
        rectifyNumber: this.rectifyNumber,
        province: this.province,
        phone: this.phone,

        // Advanced preferences
        previousTime: this.previousTime,
        currency: this.currency,
        language: this.language,
        timeZone: this.timeZone,
        proformaInvoice: this.proformaInvoice,
        cancellationAppoiments: this.cancellationAppoiments,
        cancellationAppoimentsTime: this.cancellationAppoimentsTime * 60,
        remindersSms: this.remindersSms,
        remindersWhatApp: this.remindersWhatApp,
        remindersPhone: this.remindersPhone,

        // Personalization
        tradename: this.tradename,
        webAddress: this.webAddress,
        logo: this.logo,
        copyright: this.copyright,
        spinner: this.spinner,
        welcomeMessage: this.welcomeMessage,
        colorMenu: this.colorMenu,
        colorTypography: this.colorTypography,
        colorWallpaper: this.colorWallpaper,

        //Billing
        bankAccount: this.bankAccount,
        bankAccountUse: this.bankAccountUse,

        //Payment mode
        paymentModeWallet: this.paymentModeWallet,
        paymentModeOutPlatform: this.paymentModeOutPlatform,
        paymentModeOutAfter: this.paymentModeOutAfter,
        paymentModeOutBefore: this.paymentModeOutBefore,

        //Pasarela
        paymentModePasarelaStripe: this.paymentModePasarelaStripe,
        paymentModePasarelaPaypal: this.paymentModePasarelaPaypal,
        paymentModePasarelaWallet: this.paymentModePasarelaWallet,
      };

      this.$awn.asyncBlock(
        organizationService.update(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.success.text"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.update",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            }),
          });
        },
        " "
      );
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = placeResultData.formatted_address;
      this.country = addressData.country;
      this.city = addressData.locality;
      this.postalCode = addressData.postal_code;
      this.province = addressData.administrative_area_level_1;
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    async getOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(this.organizationId),
        (response) => {
          if (response) {
            this.organization = response.data;
            this.id = response.data.id;
            this.email = response.data.email;
            this.name = response.data.name;
            this.document = response.data.document;
            this.address = response.data.address;
            this.country = response.data.country;
            this.city = response.data.city;
            this.postalCode = response.data.postalCode;
            this.prefixInvoiceNumber = response.data.prefixInvoiceNumber;
            this.invoiceNumber = response.data.invoiceNumber;
            this.prefixRectifyNumber = response.data.prefixRectifyNumber;
            this.rectifyNumber = response.data.rectifyNumber;
            this.province = response.data.province;
            this.phone = response.data.phone;
            this.phoneVuePhoneNumberInput = response.data.phone;

            // Advanced preferences
            this.previousTime = response.data.previousTime;
            this.currency = response.data.currency;
            this.timeZone = response.data.timeZone;
            this.language = response.data.language;
            this.proformaInvoice = response.data.proformaInvoice;
            this.cancellationAppoiments = response.data.cancellationAppoiments;
            this.cancellationAppoimentsTime =
              response.data.cancellationAppoimentsTime / 60;
            this.remindersSms = response.data.remindersSms;
            this.remindersWhatApp = response.data.remindersWhatApp;
            this.remindersPhone = response.data.remindersPhone;

            // Personalization
            this.tradename = response.data.tradename;
            this.webAddress = response.data.webAddress;
            this.logo = response.data.logo;
            this.welcomeMessage = response.data.welcomeMessage;
            this.copyright = response.data.copyright;
            this.spinner = response.data.spinner;

            this.getSpinner(this.spinner);
            this.colorMenu = response.data.colorMenu;
            this.colorTypography = response.data.colorTypography;
            this.colorWallpaper = response.data.colorWallpaper;

            this.changeColor();

            // Account
            this.accountId = response.data.accountId;

            //Billing
            this.bankAccount = response.data.bankAccount;
            this.bankAccountUse = response.data.bankAccountUse;

            this.paypalClientId = response.data.paypalAccountClientId;
            this.paypalSecret = response.data.paypalAccountSecret;
            this.paypalValidate = response.data.paypalAccountValidate;
            this.stripeApi = response.data.stripeAccountApi;
            this.stripePublic = response.data.stripeAccountPublic;
            this.stripeValidate = response.data.stripeAccountValidate;

            //Payment mode
            this.paymentModeWallet = response.data.paymentModeWallet;
            this.paymentModeOutPlatform = response.data.paymentModeOutPlatform;
            this.paymentModeOutAfter = response.data.paymentModeOutAfter;
            this.paymentModeOutBefore = response.data.paymentModeOutBefore;

            //Pasarela
            this.paymentModePasarelaStripe =
              response.data.paymentModePasarelaStripe;
            this.paymentModePasarelaPaypal =
              response.data.paymentModePasarelaPaypal;
            this.paymentModePasarelaWallet =
              response.data.paymentModePasarelaWallet;

            //SUPER USER
            this.superUser = response.data.superUser;
            this.isGalatea = response.data.isGalatea;

            // Custom plan
            this.planRecorded = response.data.planRecorded;
            this.planPatientWelcome = response.data.planPatientWelcome;
            this.planSendReminderWallet = response.data.planSendReminderWallet;
            this.planSendReminderWalletLimit = response.data.planSendReminderWalletLimit;
            this.galateaCodeTelesoporte = response.data.galateaCodeTelesoporte;
            this.surveyWelcomeTemplate = response.data.surveyWelcomeTemplate;
            this.planSurvey = response.data.planSurvey;
            this.planInteractive = response.data.planInteractive;
            this.planDashboardPicture = response.data.planDashboardPicture;

            this.planMulticonference = response.data.planMulticonference;
            this.planReminders = response.data.planReminders;
            this.planAlerts = response.data.planAlerts;
            this.planPayments = response.data.planPayments;
            this.planCustomize = response.data.planCustomize;
            this.planInvoice = response.data.planInvoice;
            this.planRatings = response.data.planRatings;
            this.planHc = response.data.planHc;
            this.planPetitioners = response.data.planPetitioners;
            this.planShareFiles = response.data.planShareFiles;
            this.planPublicPerfil = response.data.planPublicPerfil;
            this.planPaymentsPaypal = response.data.planPaymentsPaypal;
            this.planPaymentsStripe = response.data.planPaymentsStripe;
            this.planPaymentsWallet = response.data.planPaymentsWallet;

            this.getLogo(this.logo);
            this.getAccount();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId
            }),
          });
        },
        " "
      );
    },
    getAccount() {
      let self = this;

      accountService
        .get(this.accountId)
        .then((response) => {
          if (response) {
            self.account = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "accountService.get",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              accountId: this.accountId
            }),
          });
        });
    },
    async getAllPaymentOutPlataform() {
      let self = this;

      organizationService
        .getAllPaymentOutPlataform(this.organizationId)
        .then((response) => {
          if (response) {
            self.paymentOutPlataforms = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllPaymentOutPlataform",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId
            }),
          });
        });
    },
    updatePhone(data) {
      this.phone = data.e164;
    },
    // Payment out platform
    savePaymentOutPlataformActive(paymentOutPlataformId, active) {
      let self = this;
      this.$awn.asyncBlock(
        organizationService.savePaymentOutPlataformActive(
          this.organizationId,
          paymentOutPlataformId,
          active
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.preferences.paymentOutPlataform.active.notification.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.preferences.paymentOutPlataform.active.notification.success.text"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.savePaymentOutPlataformActive",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId,
              paymentOutPlataformId: paymentOutPlataformId,
              active: active
            }),
          });
        },
        " "
      );
    },
    deletePaymentOutPlataform(paymentOutPlataformId) {
      let self = this;
      this.$awn.asyncBlock(
        organizationService.deletePaymentOutPlataform(
          this.organizationId,
          paymentOutPlataformId
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.preferences.paymentOutPlataform.delete.notification.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.preferences.paymentOutPlataform.delete.notification.success.text"
              ),
              type: "success",
            });
            self.getAllPaymentOutPlataform();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.deletePaymentOutPlataforms",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId,
              paymentOutPlataformId: paymentOutPlataformId
            }),
          });
        },
        " "
      );
    },
    createPaymentOutPlataform() {
      this.paymentOutPlataform.organizationId = this.organizationId;
      this.paymentOutPlataform.active = true;
      this.paymentOutPlataform.defaultItem = false;

      let self = this;
      this.$awn.asyncBlock(
        organizationService.createPaymentOutPlataform(
          this.organizationId,
          this.paymentOutPlataform
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PREFERENCES", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.notification.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.notification.success.text"
              ),
              type: "success",
            });

            self.getAllPaymentOutPlataform();

            this.$bvModal.hide("modal-payment-out-plataform");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.createPaymentOutPlataform",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId,
              paymentOutPlataform: this.paymentOutPlataform
            }),
          });
        },
        " "
      );
    },
    saveFormCreatePaymentOutPlataform(evt) {
      evt.preventDefault();
      this.checkFormStep2();
      if (this.validator2.errors.length === 0) {
        //Call service to store data
        this.createPaymentOutPlataform();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.notification.error.title"
          ),
          text: this.$i18n.t(
            "public.components.organization.preferences.preferences.paymentOutPlataform.modalCreate.notification.error.text"
          ),
          type: "error",
        });
      }
    },
    openModalCreatePaymentOutPlataform() {
      this.validator2.errors = [];
      this.clearModalCreatePaymentOutPlataform();
      this.$bvModal.show("modal-payment-out-plataform");
    },
    clearModalCreatePaymentOutPlataform() {
      this.paymentOutPlataform = {
        name: "",
        active: true,
        organizationId: this.organizationId,
      };
    },
  },
  computed: {
    //Validate form
    isDisabled() {
      return this.isFirstRun === true || this.validator.errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validator.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validator.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validator.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validator.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormCityErrors() {
      let errors = this.validator.getErrors("city");
      return errors && errors.length > 0;
    },
    isFormPostalCodeErrors() {
      let errors = this.validator.getErrors("postalCode");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validator.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormBankAccountErrors() {
      let errors = this.validator.getErrors("bankAccount");
      return errors && errors.length > 0;
    },
    isFormTypeErrors() {
      let errors = this.validator.getErrors("type");
      return errors && errors.length > 0;
    },
    isFormQuantityErrors() {
      let errors = this.validator.getErrors("quantity");
      return errors && errors.length > 0;
    },
    //Validator payment out plataform
    isFormPaymentOutPlataformNameErrors() {
      let errors = this.validator2.getErrors("paymentOutPlataform.name");
      return errors && errors.length > 0;
    },
  },
  data() {
    return {
      organization: undefined,
      isGalatea: false,
      planRecorded: false,
      planPatientWelcome: false,
      planSendReminderWallet: false,
      planSendReminderWalletLimit: 0,
      galateaCodeTelesoporte: "",
      surveyWelcomeTemplate: {},
      planMulticonference: false,
      planReminders: false,
      planAlerts: false,
      planPayments: false,
      planCustomize: false,
      planInvoice: false,
      planRatings: false,
      planHc: false,
      planPetitioners: false,
      planShareFiles: false,
      planPublicPerfil: false,
      planPaymentsPaypal: false,
      planPaymentsStripe: false,
      planPaymentsWallet: false,
      planSurvey: false,
      planInteractive: false,
      planDashboardPicture: false,
      superUser: false,
      role: localStorage.getItem("role"),
      //Payments mode
      paymentModeWallet: true,
      paymentModeOutPlatform: true,
      paymentModeOutAfter: true,
      paymentModeOutBefore: true,
      //Pasarela
      paymentModePasarelaStripe: true,
      paymentModePasarelaPaypal: true,
      paymentModePasarelaWallet: true,
      //Payments client to organization
      stripeApi: "",
      stripePublic: "",
      stripeValidate: false,
      paypalClientId: "",
      paypalSecret: "",
      paypalValidate: false,

      idInvoicePay: "",
      // Invoice cita info
      idInvoiceInfo: "",
      numberInvoiceInfo: "",
      conceptInvoiceInfo: "",
      monthInvoiceInfo: "",
      yearInvoiceInfo: "",
      totalInvoiceInfo: "",
      dateInvoiceInfo: "",

      sellerInvoiceInfo: {},
      buyerInvoiceInfo: {},
      itemsInvoiceInfo: [],
      billingInvoiceInfo: {},
      variableDiv: 0,

      isFirstRun: true,
      defaultAvatar: true,
      defaultSpinner: true,
      //Data validate form
      validator: validator,
      isFirstRun: true,
      isValidate: false,
      //Form
      // My organization
      id: "",
      email: "",
      name: "",
      document: "",
      address: "",
      country: "",
      city: "",
      postalCode: "",
      prefixInvoiceNumber: "",
      invoiceNumber: 0,
      prefixRectifyNumber: "",
      rectifyNumber: 0,
      province: "",
      phone: "",
      phoneVuePhoneNumberInput: "",

      // Advanced preferences
      previousTime: "",
      currency: "",
      language: "",
      timeZone: "",
      proformaInvoice: false,
      cancellationAppoiments: "",
      cancellationAppoimentsTime: 0,
      remindersSms: "",
      remindersWhatApp: "",
      remindersPhone: "",

      // Personalization
      tradename: "",
      webAddress: "",
      logo: "",
      welcomeMessage: "",
      copyright: "",
      spinner: "",
      colorMenu: "",
      colorTypography: "",
      colorWallpaper: "",

      //Billing
      bankAccount: "",
      bankAccountUse: "",

      //Account
      disabled: false,
      validator1: validator,
      accountId: "",
      totalService: 0,
      //Pay
      stripe: {
        publicKey: "",
        idSession: "",
      },
      paypal: {
        url: "",
      },
      // Form
      quantity: 0,
      type: 0,

      quantitySelect: ReleaseServiceQuantity,
      typeSelect: ReleaseService,

      account: {},
      accountHistory: {},

      file: "",
      fileSpinner: "",

      //Load select
      timeZoneSelect: TimeZone,
      currencySelect: Currency,
      languageSelect: Language,
      sectorSelect: [],

      //Payment out plataform
      paymentOutPlataforms: [],
      validator2: validator,
      paymentOutPlataform: {
        name: "",
        active: true,
        organizationId: this.organizationId,
      },

      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },

      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/avatar/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },

      //Payment out plataform
      headers: [
        {
          text: this.$i18n.t(
            "public.auth.professional.organization.paymentOutPlataform.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.auth.professional.organization.paymentOutPlataform.active"
          ),
          align: "start",
          value: "active",
        },
        {
          text: "",
          align: "start",
          value: "actions",
        },
      ],
    };
  },
  components: {
    StripeCheckout,
    "vue-dropzone": vue2Dropzone,
    VuePhoneNumberInput,
    PreferencesAccount,
    PreferencesAdmin,
    PreferencesTemplates,
    PreferencesFooter,
    PreferencesEmail
  },
};
</script>
